// extracted by mini-css-extract-plugin
export var root = "ServiceBlock-module--root--1gOvC";
export var headingWrapper = "ServiceBlock-module--headingWrapper--3_NIz";
export var number = "ServiceBlock-module--number--2ywC9";
export var heading = "ServiceBlock-module--heading--2CtTB";
export var content = "ServiceBlock-module--content--mkhyb";
export var last = "ServiceBlock-module--last--25TyE";
export var lineBottom = "ServiceBlock-module--lineBottom--2Suhk";